import React from "react";
import {Card, Row} from "antd";
import {BarChart} from "../../../../../components/_defaultComponents/Charts/BarChart/BarChart";

export const BarReportWidget = ({
    barColor,
    data,
    drawLine = true,
    height = 300,
    title = "",
    lineColor,
    loading = true
}) => {
    return (
        <Card loading={loading}>
            {title && <Row>{title}</Row>}
            <Row justify="middle" align="top" style={{height}}>
                <BarChart
                    barColor={barColor}
                    lineColor={lineColor}
                    data={data}
                    drawLine={drawLine}
                />
            </Row>
        </Card>
    );
};
